// extracted by mini-css-extract-plugin
module.exports =  {"container":"BdxwZp1","hover":"ODZArbY","icon":"HQOsAMj","content":"N1wXU7V"};